import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import logo from "@/assets/logo.png";
import { LanguageSwitcher } from "@/components/public/LanguageSwitcher";

export const PublicNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const items = [
    { label: t("nav.tireHotel"), href: "/tire-hotel" },
    { label: t("nav.booking"), href: "/online-booking" },
    { label: t("nav.pricing"), href: "/pricing" },
  ];

  return (
    <header className="sticky top-0 z-30 bg-background/85 backdrop-blur-xl border-b hairline">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 h-16 flex md:grid md:grid-cols-[1fr_auto_1fr] items-center justify-between md:gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0 focusable rounded-lg md:justify-self-start">
          <img
            src={logo}
            alt="TireVault"
            className="h-14 md:h-[68px] w-auto object-contain"
            width={200}
            height={68}
            decoding="async"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-1 justify-self-center">
          {items.map((i) => {
            const active = location.pathname === i.href;
            return (
              <Link
                key={i.href}
                to={i.href}
                className={`px-3.5 py-1.5 rounded-full text-[14px] font-medium transition-all ${
                  active
                    ? "bg-secondary text-foreground"
                    : "text-foreground-muted hover:bg-secondary/60 hover:text-foreground"
                }`}
              >
                {i.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2 ml-auto md:ml-0 md:justify-self-end">
          <LanguageSwitcher />
          <button
            onClick={() => navigate("/auth")}
            className="hidden sm:inline-flex min-h-[40px] items-center px-3.5 py-1.5 rounded-full text-[14px] font-medium text-foreground-muted hover:bg-secondary/60 hover:text-foreground transition-colors focusable"
          >
            {t("nav.logIn")}
          </button>
          <button
            onClick={() => navigate("/auth?tab=register")}
            className="hidden sm:inline-flex items-center gap-1.5 bg-primary text-primary-foreground min-h-[40px] px-4 py-2 rounded-[10px] text-[13px] font-semibold hover:brightness-110 transition-all focusable shadow-soft"
          >
            {t("nav.getStarted")}
            <ArrowRight className="h-3.5 w-3.5" />
          </button>
          <button
            aria-label={t("common.menu")}
            onClick={() => setOpen(!open)}
            className="md:hidden flex items-center justify-center h-11 w-11 rounded-lg border hairline-2 text-foreground focusable"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t hairline bg-background">
          <nav className="max-w-[1200px] mx-auto px-4 py-3 flex flex-col gap-1.5">
            {items.map((i) => (
              <Link
                key={i.href}
                to={i.href}
                onClick={() => setOpen(false)}
                className="min-h-[48px] flex items-center px-3 rounded-lg text-[15px] font-medium text-foreground hover:bg-secondary/60"
              >
                {i.label}
              </Link>
            ))}
            <div className="border-t hairline mt-2 pt-2 flex flex-col gap-1.5">
              <Link
                to="/auth"
                onClick={() => setOpen(false)}
                className="min-h-[48px] flex items-center px-3 rounded-lg text-[15px] font-medium text-foreground hover:bg-secondary/60"
              >
                {t("nav.logIn")}
              </Link>
              <Link
                to="/auth?tab=register"
                onClick={() => setOpen(false)}
                className="min-h-[48px] flex items-center justify-center px-3 rounded-lg text-[15px] font-semibold bg-primary text-primary-foreground"
              >
                {t("nav.getStarted")}
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
